module.exports = "/assets/data/fdc1488b0783d007c2be14ccd4083eff-HU7.data.json";